import moment from "moment";
import { IBranchDto, IStaffDto } from "../dto/app-init.dto";

export const formatValue = (
  value?: number,
  isReversal: boolean = false,
  isCurrency: boolean = true,
  isShowZero: boolean = false
) => {
  value = value ? value : 0;
  if (value === 0 && !isShowZero) return "";

  let result = value.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (isReversal) result = `(${result})`;
  return isCurrency ? `£${result}` : result;
};

export function formatDateForAPI(date: string) {
  if (!date) {
    return "";
  }
  let value = moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
  return value;
}

export const getFormattedUFN = (ufnNumber?: string, ufnDate?: string) => {
  return `${getFormattedUFNDate(ufnDate)}/${ufnNumber}`;
};

export const getFormattedUFNDate = (ufnDate?: string) => {
  if (!!ufnDate) {
    const val = moment(ufnDate, "DD/MM/YYYY").format("DDMMYY");
    return val;
  } else {
    return "";
  }
};

export const isNullOrEmptyGuid = (guid?: string) => {
  if (!guid || guid === "00000000-0000-0000-0000-000000000000" || guid === "") {
    return true;
  }
  return false;
};

export const newGuid = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const roundAwayFromZero = (number: number, decimalPlaces: number) => {
  var factor = Math.pow(10, decimalPlaces || 0);
  return (Math.round(number * factor) * (1 + Number.EPSILON)) / factor;
};

export const filterInactiveStaff = (
  staffList?: IStaffDto[],
  currentId?: string
) => {
  return (staffList || [])
    .filter((s) => s.__id === currentId || !s.status)
    .sort(
      (a, b) =>
        (`${a.firstName} ${a.lastName}` < `${b.firstName} ${b.lastName}` &&
          1) ||
        -1
    )
    .sort((a, b) => (a.status > b.status ? 1 : -1))
    .map((s) => {
      return {
        ...s,
        firstName: s.status !== 0 ? "{Inactive} " + s.firstName : s.firstName,
      };
    });
};

export const filterBranches = (branchList?: IBranchDto[]) => {
  return (branchList || [])
    .filter((b) => b.deleteCode === 0)
    .sort((a, b) => (`${a.displayName}` > `${b.displayName}` && 1) || -1);
};
